<template>
    <div class="">
        <AutoriaIndex :showvolver="true" :isgeneral="true" />
        <p class="mb-14 pt-8"></p>
        <LibreIndex :showvolver="false" :isgeneral="true" />
        <p class="mb-14 pt-8"></p>
        <AltoRenIndex :showvolver="false" :isgeneral="true" />
        <p class="mb-14 pt-8"></p>
    </div>
</template>
  
<script>  
import AutoriaIndex from '@/views/oferta_academica/autoria/index_autoria.vue'
import LibreIndex from '@/views/oferta_academica/libre/index_libre.vue'
import AltoRenIndex from '@/views/oferta_academica/rendimiento/index_rendimiento.vue'

export default {
    components: { AutoriaIndex,LibreIndex,AltoRenIndex },
    data() {
        return { 
        };
    },
    watch: { },
    methods: { 
    },
    mounted() { 
    },
};
</script>
  